module.exports = __webpack_public_path__ + "static/media/range_2_green.f46971d6.png";